/// <reference path="../../../types/quill-shims/index.d.ts" />
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import imageCompressor from 'quill-image-compress';
import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from 'quill-image-resize-module';
import * as QuillNamespace from 'quill';

const Quill: any = QuillNamespace;

// Enable the image paste, drop, compression, and resize behavior already used by ASCC editors.
Quill.register('modules/imageDrop', ImageDrop, true);
Quill.register('modules/imageResize', ImageResize, true);
Quill.register('modules/imageCompressor', imageCompressor, true);

export const WORKFLOW_ASSISTANT_RICH_TEXT_MAX_LENGTH = 2000000;

export const WORKFLOW_ASSISTANT_QUILL_CONFIG = {
  toolbar: {
    container: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ['link', 'image'],
      ['clean'],
    ],
  },
  imageDrop: true,
  imageResize: true,
  imageCompressor: {
    quality: 0.8,
    maxWidth: 1200,
    maxHeight: 1200,
    imageType: 'image/jpeg',
    suppressErrorLogging: true,
  },
};

/**
 * Requires visible text or an embedded image instead of accepting Quill's empty HTML shell.
 */
export function richTextRequired(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = `${control.value ?? ''}`;
    const text = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim();
    return text || /<img\b/i.test(value) ? null : { required: true };
  };
}
